/**
 * @file: markdownToPlain.ts
 *
 * Light markdown→plain-text flatten for one-line previews (inbox row, quote
 * snapshot). Strips code fences, links/images, headings, blockquotes, list
 * bullets and inline emphasis — enough for a compact summary, not a parser.
 */

export function markdownToPlain(md: string): string {
  return md
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/`([^`]*)`/g, '$1')
    .replace(/!\[[^\]]*\]\([^)]*\)/g, ' ')
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/^\s{0,3}>\s?/gm, '')
    .replace(/^\s*[-*+]\s+/gm, '')
    .replace(/[*_~]{1,3}/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}
